import { Stack } from '@mui/material';

import GlobalChangelog from '@/designs-dev/inspect/GlobalChangelog';

// The compiled design-system changelog across every prototype. It used to lead
// the Home landing; Home is now the zone overview, so the changelog has its own
// route, reached from the menu footer.
function Changelog() {
  return (
    <Stack sx={{ flex: 1, p: 3, minHeight: 0, overflow: 'auto' }}>
      <GlobalChangelog />
    </Stack>
  );
}

export default Changelog;
